
































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FiltersModule from '@/store/FiltersModule';
import ListModule from '@/store/ListModule';
import AuthModule from '@/store/AuthModule';
import { typesArr, types2Arr, exposuresArr } from '@/data/types';
import regions from '@/data/regions';
import departments from '@/data/departments';
import taxSystems from '@/data/taxSystems';
import cities, { City } from '@/data/cities';

import { fetchPromotorsPrescriber, fetchProgramsPrescriber, fetchProgramsPrescriberById, fetchUnifiedLocations } from '@/utils/filters';

import LocationFilterComponent from '@/components/LocationFilterComponent.vue';
import ProgramSearchComponent from '@/components/ProgramSearchComponent.vue';
import PromotorSearchComponent from '@/components/PromotorSearchComponent.vue';

import BRSModal from '@/components/prescriber/BRSModal.vue';
import BRSPopup from '@/components/prescriber/BRSPopup.vue';
import LLIModal from '@/components/prescriber/LLIModal.vue';

import moment from 'moment';
import chunk from 'lodash/chunk';

@Component({
  components: {
    LocationFilterComponent,
    ProgramSearchComponent,
    PromotorSearchComponent,
    BRSModal,
    BRSPopup,
    LLIModal
  }
})
export default class FilterPopup extends Vue {
  @Prop({ default: false }) visible!: boolean;
  
  activeCategory: string = 'location';
  expandedFamilies: string[] = [];
  familiesSelected: string[] = [];
  
  cities: City[] = [];
  
  showTypes = false;
  showRooms = false;
  showOrientations: boolean = false;

  selectedLocations: any[] = [];
  locationDetailsCache: any[] = [];

  isPrivateMode: boolean = false;

  livrablePopup: boolean = false;
  actablePopup: boolean = false;
  pinelPlusPopup: boolean = false;
  brsPopup: boolean = false;
  lliPopup: boolean = false;

  showUsufruitControls: boolean = false;
  showNueProControls: boolean = false;
  // ============================================================
  // FIX: showReventeControls est maintenant un COMPUTED (plus une data property)
  // Cela le rend réactif même quand la famille entière est activée via filterTaxes()
  // ============================================================

  programCount: number | null = null;
  selectedProgramForDisplay: any = null;
  isApplying: boolean = false;


  get isVisible() {
    return this.visible;
  }

  get meta() {
    return ListModule.meta;
  }

  closePopup(): void {
    this.isVisible = false;
  }

  set isVisible(value: boolean) {
    this.$emit('update:visible', value);
  }

  get filters() {
    return FiltersModule.filters;
  }

  get operators() {
    let meta = ListModule.meta;
    if (meta.operators) {
      return [...new Set(meta.operators)].filter(Boolean).sort();
    }
    return [];
  }

  categories = [
    { id: 'location', name: 'Localisation', icon: 'fas fa-map-marker-alt', hasStars: true },
    { id: 'property', name: 'Bien(s)',       icon: 'fas fa-building' },
    { id: 'fiscal',   name: 'Fiscalité(s)',  icon: 'fas fa-calculator', hasStars: true },
    { id: 'program',  name: 'Programme(s)',  icon: 'fas fa-city' }
  ];

  taxSystemFamily = {
    VEFA: 'Régime général VEFA',
    LMNPVEFA: 'LMNP avec Bail Co. VEFA',
    ANCIEN: 'Ancien à Réhab.',
    LMNPREV: 'Revente LMNP',
    LOCALPRO: 'Local Pro',
  };

  get regions() {
    return regions;
  }

  get departements() {
    return departments;
  }

  get typesArr() {
    return typesArr;
  }

  get types2Arr() {
    return types2Arr;
  }

  get types2ArrChunks() {
    return chunk(types2Arr, 3);
  }

  get exposuresArr() {
    return exposuresArr;
  }

  get taxSystems() {
    return taxSystems;
  }

  // ============================================================
  // FIX: showReventeControls en COMPUTED au lieu de data property
  // S'active automatiquement dès qu'une taxe Revente est dans filters.taxes,
  // que ce soit via toggle individuel OU via activation de toute la famille
  // ============================================================
  get showReventeControls(): boolean {
    const reventeTaxes = [
      "Revente LMNP",
      "Revente LMNP Tourisme",
      "Revente LMNP Étudiant",
      "Revente LMNP Sénior",
      "Revente LMNP Rés",
      "Revente LMNP EHPAD"
    ];
    return this.filters.taxes.some((tax: string) => reventeTaxes.includes(tax));
  }

  get selectedTypesText(): string[] {
    return this.filters.types.map((value: string) => {
      const item = this.typesArr.find((t: any) => t.value === value);
      return item ? item.text : value;
    });
  }

  get selectedRoomsText(): string[] {
    const flatArr = this.types2ArrChunks.flat();
    return this.filters.types2.map((value: string) => {
      const item = flatArr.find((t: any) => t.value === value);
      return item ? item.text : value;
    });
  }

  get selectedExposuresText(): string[] {
    return this.filters.exposures.map((value: string) => {
      const item = this.exposuresArr.find(e => e.value === value);
      return item ? item.text : value;
    });
  }

  get privateMode() {
    return FiltersModule.privateMode;
  }

  get commercialOffersChoices() {
    return [
      { text: 'Tout',         value: null  },
      { text: 'Boost Hono',   value: true  },
      { text: 'Avant. Client', value: false },
    ];
  }

  get dangerBudget() {
    return this.filters.dutyFreeFeeMin > 20;
  }

  get fetchPromotorsPrescriber() {
    return fetchPromotorsPrescriber;
  }

  get fetchProgramsPrescriber() {
    return fetchProgramsPrescriber;
  }

  get fetchUnifiedLocations() {
    return fetchUnifiedLocations;
  }

  get pinelZone() {
    const zones: Record<string, string> = {
      Abis: 'A bis',
      A: 'A',
      B1: 'B1',
      B2: 'B2',
      C: 'C',
    };
    return Object.keys(zones).map(key => ({
      text: zones[key],
      value: key,
    }));
  }

  toggleTaxItem(taxValue: string) {
    const index = this.filters.taxes.indexOf(taxValue);
    if (index > -1) {
      this.filters.taxes.splice(index, 1);
    } else {
      this.filters.taxes.push(taxValue);
    }
    this.updateFamilySelections();
  }

  async fetchCitiesPrescriber(input: string) {
    const { data } = await cities(input);
    this.cities = data;
    return data.map((el) => ({
      text: `${el.nom} (${el.departement.code})`,
      value: el.code,
    }));
  }

  onFilterCity(value: string) {
    if (!value) {
      this.filters.city = undefined;
      return;
    }
    const city = this.cities.find((x) => x.code === value);
    if (city) {
      this.filters.city = city.nom;
      this.filters.departement = city.departement.code;
    }
  }

  onFilterPromotor(value: number | undefined) {
    this.filters.promotor = value;
  }

  onFilterProgram(value: any) {
    this.selectedProgramForDisplay = value || null;
    FiltersModule.setSelectedProgram(value && value.status !== 'sold' ? value : null);
    if (value) {
      if (value.status !== 'sold') {
        this.filters.program = value.id;
      } else {
        this.filters.program = null;
      }
    } else {
      this.filters.program = null;
    }
  }

  // Program filter changed elsewhere (list header search, reset...): mirror it here
  @Watch('filters.program')
  onStoreProgramChange(id: any) {
    const shown = this.selectedProgramForDisplay;
    if (shown && (shown.id === id || (!id && shown.status === 'sold'))) return;
    const selected = FiltersModule.selectedProgram;
    const active = id && selected && selected.id === id ? selected : null;
    this.selectedProgramForDisplay = active;
    const byName = this.$refs.program as any;
    const byId = this.$refs.programId as any;
    if (byName) byName.setSelected(active);
    if (byId) byId.resetUI();
  }

  toggleTypes(): void {
    this.showTypes = !this.showTypes;
    if (this.showTypes) { this.showRooms = false; this.showOrientations = false; }
  }

  toggleRooms(): void {
    this.showRooms = !this.showRooms;
    if (this.showRooms) { this.showTypes = false; this.showOrientations = false; }
  }

  toggleOrientations(): void {
    this.showOrientations = !this.showOrientations;
    if (this.showOrientations) { this.showTypes = false; this.showRooms = false; }
  }

  toggleType(value: string): void {
    const idx = this.filters.types.indexOf(value);
    idx > -1 ? this.filters.types.splice(idx, 1) : this.filters.types.push(value);
  }

  toggleRoom(value: string): void {
    const idx = this.filters.types2.indexOf(value);
    idx > -1 ? this.filters.types2.splice(idx, 1) : this.filters.types2.push(value);
  }

  toggleExposure(value: string): void {
    const idx = this.filters.exposures.indexOf(value);
    idx > -1 ? this.filters.exposures.splice(idx, 1) : this.filters.exposures.push(value);
  }

  removeType(text: string): void {
    const item = this.typesArr.find((t: any) => t.text === text);
    if (!item) return;
    const idx = this.filters.types.indexOf(item.value);
    if (idx > -1) this.filters.types.splice(idx, 1);
  }

  removeRoom(text: string): void {
    const flatArr = this.types2ArrChunks.flat();
    const item = flatArr.find((t: any) => t.text === text);
    if (!item) return;
    const idx = this.filters.types2.indexOf(item.value);
    if (idx > -1) this.filters.types2.splice(idx, 1);
  }

  removeExposure(text: string): void {
    const item = this.exposuresArr.find(e => e.text === text);
    if (!item) return;
    const idx = this.filters.exposures.indexOf(item.value);
    if (idx > -1) this.filters.exposures.splice(idx, 1);
  }

  isFamilySelected(taxe: string) {
    return this.familiesSelected.includes(taxe);
  }

  filterTaxes(taxe: string) {
    if (this.familiesSelected.includes(taxe)) {
      const index = this.familiesSelected.indexOf(taxe);
      this.familiesSelected.splice(index, 1);
      const familyTaxes = this.taxSystems
        .filter(item => item.family === taxe)
        .map(item => item.value);
      this.filters.taxes = this.filters.taxes.filter(
        (tax: string) => !familyTaxes.includes(tax)
      );
    } else {
      this.familiesSelected.push(taxe);
      this.taxSystems.forEach(element => {
        if (element.family === taxe && !this.filters.taxes.includes(element.value)) {
          this.filters.taxes.push(element.value);
        }
      });
    }
    // showReventeControls est computed → se met à jour automatiquement
  }

  toggleTaxFamily(familyKey: string): void {
    const index = this.expandedFamilies.indexOf(familyKey);
    index > -1 ? this.expandedFamilies.splice(index, 1) : this.expandedFamilies.push(familyKey);
  }

  handleExclusiveCheckbox(selected: string) {
    if (this.filters[selected]) {
      const checkboxes = ['includeDeliveryTrimester', 'isLivrable', 'isActable'];
      checkboxes.forEach(item => {
        if (item !== selected) this.filters[item] = false;
      });
    }
  }

  handleCheckboxChange(selected: string) {
    this.handleExclusiveCheckbox(selected);
  }

  updateSurfaceMin(value: string) {
    const numValue = parseInt(value) || 0;
    Vue.set(this.filters.surfaceInterval, 0, numValue);
    this.filters.includeSurface = numValue > 0 || this.filters.surfaceInterval[1] > 0;
  }

  updateSurfaceMax(value: string) {
    const numValue = parseInt(value) || 200;
    Vue.set(this.filters.surfaceInterval, 1, numValue);
    this.filters.includeSurface = this.filters.surfaceInterval[0] > 0 || numValue > 0;
  }

  updateSurfaceExtMin(value: string) {
    const numValue = parseInt(value) || 0;
    Vue.set(this.filters.surfaceExtInterval, 0, numValue);
    this.filters.includeExtSurface = numValue > 0 || this.filters.surfaceExtInterval[1] > 0;
  }

  updateSurfaceExtMax(value: string) {
    const numValue = parseInt(value) || 200;
    Vue.set(this.filters.surfaceExtInterval, 1, numValue);
    this.filters.includeExtSurface = this.filters.surfaceExtInterval[0] > 0 || numValue > 0;
  }

  validateProfitabilityInput() {
    if (this.filters.profitabilityMin === null || this.filters.profitabilityMin === '') return;
    let value = parseFloat(this.filters.profitabilityMin);
    if (isNaN(value)) { this.filters.profitabilityMin = 0; return; }
    if (value > 30) { this.filters.profitabilityMin = 30; }
    this.filters.profitabilityMin = parseFloat(value.toFixed(1));
    this.filters.includeProfitabilityMin = value > 0;
  }

  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  isNumber(evt: KeyboardEvent) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 44) {
      evt.preventDefault();
    } else {
      return true;
    }
  }

  surfaceFormatter(value: number) {
    return value;
  }

  timeFormatter(value: number) {
    value -= 40;
    const currentQuarter = moment().quarter();
    const date = moment().quarter(currentQuarter + value).startOf('quarter');
    return `${date.quarter()}T.${date.year()}`;
  }

  onPopupStateChange(isOpen: boolean) {
    if (isOpen) {
      this.updateFamilySelections();
      if (this.filters.country === undefined) {
        this.filters.country = '';
      }
    }
  }

  updateFamilySelections() {
    this.familiesSelected = [];
    Object.keys(this.taxSystemFamily).forEach(familyKey => {
      const familyTaxes = this.taxSystems
        .filter(item => item.family === familyKey)
        .map(item => item.value);
      const hasAllFamilyTaxes = familyTaxes.every(tax => this.filters.taxes.includes(tax));
      if (hasAllFamilyTaxes && familyTaxes.length > 0) {
        this.familiesSelected.push(familyKey);
      }
    });
  }

  resetFilters(): void {
    if (this.$refs.city) (this.$refs.city as any).clear();
    if (this.$refs.program) (this.$refs.program as any).clear();
    if (this.$refs.programId) (this.$refs.programId as any).clear();
    if (this.$refs.promotor) (this.$refs.promotor as any).clear();

    this.familiesSelected = [];
    this.expandedFamilies = [];
    this.selectedProgramForDisplay = null;

    const defaultFilters = {
      status: '',
    };

    Object.keys(defaultFilters).forEach(key => {
      Vue.set(this.filters, key, (defaultFilters as any)[key]);
    });

    ListModule.setLotsSelected([]);
    localStorage.removeItem('customerIDDenouncedFresh');
  }

  applyFilters() {
    this.isApplying = true;
    setTimeout(() => {
      FiltersModule.onFilters(this.filters);
      this.$emit('filtersApplied');
      this.isVisible = false;
      this.isApplying = false;
    }, 150);
  }

  mounted(): void {
    document.addEventListener('click', (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.custom-vuesax-select')) {
        this.showTypes = false;
        this.showRooms = false;
        this.showOrientations = false;
      }
    });
  }

  togglePrivateMode() {
    this.isPrivateMode = !this.isPrivateMode;
    FiltersModule.togglePrivateMode();
  }

  async fetchProgramsPrescriberWithCount(value: string, meta?: any) {
    if (value.length < 3) { this.programCount = null; return []; }
    const results = await fetchProgramsPrescriber(value, meta);
    this.programCount = results.length;
    return results;
  }

  async fetchProgramsPrescriberByIdWithCount(value: string, meta?: any) {
    if (!value) return [];
    const results = await fetchProgramsPrescriberById(value, meta);
    this.programCount = results.length;
    return results;
  }

  toggleTaxItemWithLogic(taxValue: string, type: string) {
    const index = this.filters.taxes.indexOf(taxValue);
    index > -1 ? this.filters.taxes.splice(index, 1) : this.filters.taxes.push(taxValue);

    const taxItem = this.taxSystems.find(item => item.value === taxValue);
    if (taxItem) this.autoSelectFamily(taxItem.family);

    if (type === 'demembrement') {
      this.handleDemembrementChange();
    }
    // NOTE: handleReventeChange n'est plus nécessaire pour showReventeControls
    // car c'est maintenant un computed. On garde juste le reset du bail si nécessaire.
    else if (type === 'revente') {
      this.handleReventeResetIfNeeded();
    }

    this.updateFamilySelections();
  }

  autoSelectFamily(familyKey: string) {
    if (!this.familiesSelected.includes(familyKey)) {
      this.familiesSelected.push(familyKey);
    }
  }

  isReventeTax(taxValue: string): boolean {
    const reventeTaxes = [
      "Revente LMNP",
      "Revente LMNP Tourisme",
      "Revente LMNP Étudiant",
      "Revente LMNP Sénior",
      "Revente LMNP Rés",
      "Revente LMNP EHPAD"
    ];
    return reventeTaxes.includes(taxValue);
  }

  handleDemembrementChange() {
    const isDemembrementSelected = this.filters.taxes.includes('Démembrement de propriété');
    this.showUsufruitControls = isDemembrementSelected;
    this.showNueProControls = isDemembrementSelected;
    if (!isDemembrementSelected) {
      this.filters.includeUsufruitDuration = false;
      this.filters.includeNuePro = false;
      this.filters.dureeNueProInterval = [null, null];
    }
  }

  // ============================================================
  // FIX: handleReventeChange simplifié — showReventeControls est
  // maintenant un computed, on gère uniquement le reset du bail
  // ============================================================
  handleReventeResetIfNeeded() {
    // Si plus aucune taxe revente n'est sélectionnée, reset le bail
    if (!this.showReventeControls) {
      this.filters.includeBailDuration = false;
      this.filters.bailDurationInterval = [0, 20];
    }
  }

  isPinel(): boolean {
    return (
      this.filters.taxes.includes('Pinel / Rés. principale') ||
      this.filters.taxes.includes('RP Tva Réduite/Prix Maitrisé') ||
      this.filters.taxes.includes('PINEL Sénior') ||
      this.filters.taxes.includes('PINEL Outre Mer') ||
      this.filters.taxes.includes('BRS') ||
      this.filters.taxes.includes('LLI') ||
      this.filters.brs
    );
  }

  isOnlyPinel(): boolean {
    return (
      this.filters.taxes.includes('Pinel / Rés. principale') ||
      this.filters.taxes.includes('RP Tva Réduite/Prix Maitrisé') ||
      this.filters.taxes.includes('PINEL Sénior') ||
      this.filters.taxes.includes('PINEL Outre Mer') ||
      this.filters.taxes.length == 0
    );
  }

  isAncienARehab(): boolean {
    return (
      this.filters.taxes.includes('PINEL Ancien') ||
      this.filters.taxes.includes('Denormandie') ||
      this.filters.taxes.includes('Malraux') ||
      this.filters.taxes.includes('Monuments historiques') ||
      this.filters.taxes.includes('Déficits fonciers') ||
      this.filters.taxes.includes('Projet construction') ||
      this.filters.taxes.includes('Loi COSSE Ancien-Louer Abordable')
    );
  }

  usufruitFormatter(value: number) { return value + ' ans'; }
  nueProFormatter(value: number)   { return value + '%'; }
  bailDurationFormatter(value: number) { return value + ' ans'; }

  toggleApiConnected() {
    this.filters.type_flux = this.filters.type_flux === 'aut' ? null : 'aut';
  }

  selectedLocation: any = undefined;


    onUnifiedLocationChange(values: any[]) {
      if (!values || values.length === 0) {
        this.filters.region = undefined;
        this.filters.departement = undefined;
        this.filters.city = undefined;
        this.filters.cp = undefined;
        this.selectedLocations = [];
        this.locationDetailsCache = [];
        return;
      }

      this.locationDetailsCache = values;

      const regions: string[] = [];
      const departements: string[] = [];
      const cities: string[] = [];
      const cps: string[] = [];

      values.forEach((location: any) => {
        if (location.type === 'Region') {
          regions.push(location.value);
        } else if (location.type === 'Departement') {
          departements.push(location.value);
        } else if (location.type === 'Ville') {
          cities.push(location.value);
          if (location.postalCode) {
            cps.push(location.postalCode);
          }
        } else if (location.type === 'Code postal') {
          cps.push(location.value);
        }
      });

      this.filters.region = regions.length > 0 ? regions : undefined;
      this.filters.departement = departements.length > 0 ? Array.from(new Set(departements)) : undefined;
      this.filters.city = cities.length > 0 ? cities : undefined;
      this.filters.cp = cps.length > 0 ? Array.from(new Set(cps)) : undefined;
      this.selectedLocations = values.map(v => `${v.type}||${v.value}`);
    }



  getSelectedLocationDetails() {
    return this.locationDetailsCache;
  }

  getLocationTypeClass(type: string): string {
    const typeMap: any = {
      'Region': 'type-region',
      'Departement': 'type-departement',
      'Ville': 'type-ville',
      'Code postal': 'type-postal'
    };
    return typeMap[type] || '';
  }

  getLocationTypeIcon(type: string): string {
    const iconMap: any = {
      'Region': '🌍',
      'Departement': '📍',
      'Ville': '🏙️',
      'Code postal': '📮'
    };
    return iconMap[type] || '📌';
  }

  removeLocation(index: number) {
    this.locationDetailsCache.splice(index, 1);
    this.selectedLocations = this.locationDetailsCache.map(v => `${v.type}||${v.value}`);
    this.onUnifiedLocationChange(this.locationDetailsCache);
  }

  openLivrablePopup() { this.livrablePopup = true; }
  openActablePopup()  { this.actablePopup  = true; }
}
